/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { injectIntl } from 'react-intl'
import { BarChart } from '../components/bar_chart/BarChart'
import { getDaysActive } from '../crud/elastic.crud'
import { GeneralError } from '../partials/content/GeneralError'
import Spinner from '../partials/content/Spinner'

function DaysActiveWidget(props) {
  const { data, customerId, url, startDate, endDate, aggregateByEmployee, currentFilters } = props

  const [daysActiveData, setDaysActiveData] = useState()
  const [isLoading, setIsLoading] = useState(false) // Set during data retrieval
  const [isError, setIsError] = useState(false) // Set if there is an error making data call

  // If data is passed in, we do not need to make another call to /elastic/usage
  useEffect(() => {
    if (data) {
      setDaysActiveData(data)
    }
  }, [data])

  useEffect(() => {
    if (data || !customerId || !startDate || !endDate) {
      return
    }
    // eslint-disable-next-line no-use-before-define
    getAppUsageData()
  }, [startDate, endDate, customerId, currentFilters]) // eslint-disable-line react-hooks/exhaustive-deps

  // Handles making call to /elastic/usage to retrieve daily usage data
  const getAppUsageData = async () => {
    try {
      setIsLoading(true)
      const response = await getDaysActive(
        customerId,
        url,
        startDate,
        endDate,
        aggregateByEmployee,
        currentFilters.jobTitle,
        currentFilters.employee,
        currentFilters.department,
      )

      // This is only used currently when aggregateByEmployee is set to false. The ApplicationDetailsModal passes the data in as a prop for each employee to avoid needing to make this data call and filter through the employees array in the response
      setDaysActiveData(response.data.activeUsers[0])
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      setIsError(true)
      console.error(error)
    }
  }

  // Used for calculating the margin between each chart. Because the initial week may have leading null days, they may need much less margin (distance between dots)
  const calculateRightMarginBetweenCharts = (index) => {
    const nonNullDays = Object.values(daysActiveData.daysActive[index]).filter(
      (chartObject) => chartObject !== null,
    ).length

    if (index === 0) {
      // Below is some hard-to-read data manipulation which basically takes the daysActive array and transforms it to find the total number of non-null days for the week of the index passed in
      if (nonNullDays === 1) {
        return '2px'
      }
      if (nonNullDays === 2) {
        return '10px'
      }
      if (nonNullDays === 4 || nonNullDays === 5) {
        return '17px'
      }
      return '18px'
    }
    // Default right-margin for the charts after the first one
    return '18px'
  }

  return (
    <div style={{ marginTop: '-30px' }}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {isError ? (
        <GeneralError />
      ) : !isError && (isLoading || !daysActiveData) ? (
        <Spinner />
      ) : (
        <Row>
          <Col style={{ display: 'flex', alignItems: 'end', padding: '0px' }}>
            {daysActiveData?.daysActive.map((week, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={`days-active-${index}`}>
                <Col
                  style={{
                    padding: '0px',
                    maxWidth: 'fit-content',
                    marginRight: calculateRightMarginBetweenCharts(index),
                  }}
                >
                  <BarChart
                    usersActivity={week}
                    totalUsers={daysActiveData.totalUsers}
                    index={index}
                    // eslint-disable-next-line no-unsafe-optional-chaining
                    maxIndex={daysActiveData?.daysActive?.length - 1}
                    colorConfiguration={{
                      success: 'var(--aug-activity-bar-success)',
                      empty: 'var(--aug-fill-muted-empty)',
                    }}
                  />
                </Col>
              </React.Fragment>
            ))}
          </Col>
        </Row>
      )}
    </div>
  )
}

export default injectIntl(DaysActiveWidget)
